export default {
	API_URL: 'https://api-seft.infinitum-ti.com/api',
	OAPI_URL: 'https://api-seft.infinitum-ti.com/oapi',
	// API_URL: 'http://localhost:2402/api',
	// OAPI_URL: 'http://localhost:2402/oapi',
}
